// extracted by mini-css-extract-plugin
export default {"angleInput":"AngleInput_angleInput__yB-OG"};